import * as React from 'react';
import Stack from '@mui/material/Stack';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';

export default function Header({ headerTitle }) {
  return (
    <Stack
      direction="row"
      component="header"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
        py: 1.5,
        px: 0.5,
        backdropFilter: 'blur(12px)',
        bgcolor: (theme) =>
          theme.palette.mode === 'light'
            ? 'rgba(248, 250, 252, 0.92)'
            : 'rgba(15, 23, 42, 0.88)',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs headerTitle={headerTitle} />
      <ColorModeIconDropdown />
    </Stack>
  );
}
